//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';


//Material-ui
import Button from '@material-ui/core/Button';

//Part
import PartPageTitle from './PartPageTitle';


class Comp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      googleOauthSubject: null,
      googleOauthState: null,
    }
  }

  componentDidMount() {
    document.title = 'Googleアカウントでログイン - パートナーズ';
    this.props.settingGoogleOauthCheck((data) => {
      let state;
      if (data.subject) {
        state = true;
      }
      else {
        state = false;
      }
      this.setState({googleOauthSubject:data.subject, googleOauthState:state});
    });
  }


  render() {
    let content;
    let link = "https://accounts.google.com/o/oauth2/auth?client_id=1066279439957-lfntc57slit74jhgfnfp62ku9ckhkq5u.apps.googleusercontent.com&redirect_uri=https://www.partner-s.net/oauth/editGoogleOauth.php&response_type=code&scope=https://www.googleapis.com/auth/userinfo.email&access_type=offline";

    content = (
      <div>
        <h3 align='center' style={{padding:'10px'}}>
          Googleアカウントでログインとは?
        </h3>
        <div style={{maxWidth:'400px', margin:'auto'}}>
          Googleアカウントと連携することで、ログインする際にIDとパスワードを入力する必要がなくなります。
        </div>
        {
          (this.state.googleOauthState === true) ? (
            <div align='center'>
              <h3 style={{padding:'10px'}}>
                Googleアカウントは連携済です
              </h3>

              <Button
                variant="outlined"
                onClick={ () => window.location.replace(link) }
              >
                別のGoogleアカウントと連携する
              </Button>
              <div style={{maxWidth:'400px', margin:'auto', color:'#666' ,fontSize:'0.9em'}}>
                ブラウザ側で事前に新しく連携する<br />アカウントでログインしてください。
              </div>
            </div>
          ):(
            <div align='center'>
              <Button
                variant="outlined"
                onClick={ () => window.location.replace(link) }
              >
                Googleアカウントと連携する
              </Button>
            </div>

          )
        }

      </div>
    )


    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'Googleアカウントでログイン'}
          onback={ '/setting/' }
        />
        {
          content
        }
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
